var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-chat",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.102,2.999l-14.174,0c-1.32,0 -2.396,1.078 -2.396,2.364c-0,0 -0.033,9.888 -0.033,9.888c0,1.32 1.077,2.364 2.397,2.364c0,-0 3.557,-0.032 3.557,-0.032c-0,-0 -0,2.884 -0,2.884c-0,0.434 0.486,0.686 0.843,0.428l4.459,-3.345c0,0 5.315,0.033 5.315,0.033c1.32,-0 2.429,-1.078 2.429,-2.365l0.053,-9.855c-0.001,-1.286 -1.098,-2.364 -2.45,-2.364Zm1.021,12.219c-0,0.578 -0.444,1.147 -1.021,1.147c-0,0 -5.352,-0.032 -5.352,-0.032c-0.27,-0 -0.533,0.087 -0.749,0.25l-3.169,2.379l-0,-1.956c-0,-0.372 -0.302,-0.673 -0.674,-0.673c0,-0 -4.23,0.032 -4.23,0.032c-0.577,0 -1.017,-0.537 -1.017,-1.114l-0,-9.855c-0,-0.578 0.472,-1.05 1.05,-1.05c-0,-0 14.173,-0 14.173,-0c0.577,-0 1.05,0.472 1.05,1.05c-0,-0 -0.061,9.822 -0.061,9.822Zm-7.524,-3.831l-4.595,0c-0.369,0 -0.671,0.3 -0.673,0.668c-0.035,0.371 0.301,0.679 0.673,0.679l4.595,0c0.372,0 0.641,-0.302 0.641,-0.674c0,-0.371 -0.269,-0.673 -0.641,-0.673Zm3.446,-3.446l-8.041,0c-0.369,0 -0.671,0.3 -0.673,0.668c-0.035,0.371 0.301,0.679 0.673,0.679c-0,-0 8.041,-0 8.041,-0c0.372,-0 0.642,-0.302 0.642,-0.674c-0,-0.371 -0.27,-0.673 -0.642,-0.673Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass2",
    serifid: "magnifying-glass"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRChat);
export default __webpack_public_path__ + "static/media/iconR-chat.04f48440d712fc37e7b919c4c06fe398.svg";
export { ForwardRef as ReactComponent };